export default "__VITE_ASSET__Ble6$prx__"